import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';

const styles = require('./image-component.styles.scss');


export class ImageComponent extends React.Component {
  static propTypes = {
    round: PropTypes.bool,
    width: PropTypes.number,
    height: PropTypes.number,
    border: PropTypes.bool,
    className: PropTypes.string,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }

  static defaultProps = {
    radius: 0,
    border: false,
    className: '',
    alt: '',
  }

  render() {
    const { round, width, height, border, ...props } = this.props;
    const className = classnames(styles.Image, this.props.className, {
      [styles.border]: this.props.border,
      [styles.round]: this.props.round,
    });

    return (
      <img alt='' {...props} className={className} style={this.style} />
    );
  }

  get style() {
    const { width, height } = this.props;
    const style = {};

    if (width) { style.maxWidth = width; }
    if (height || width) { style.maxHeight = height || width; }

    return style;
  }
}



// WEBPACK FOOTER //
// ./src/components/image/image.component.jsx